import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

export default id => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return axiosGlobalInstance({
    method: 'POST',
    url: '/survey.php',
    data: { id },
    headers: {
      token: decipher?.token?.value,
      action: 'deleteAnswer',
    }
  });
}
